import React, { useEffect, useState } from "react"
import Container from "../hoc/container/Container"
import SubscribeForm from "../components/subscribeForm/SubscribeForm"
import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import Nav from "../components/nav/Nav"
import style from "./discount.module.css"

const DiscountPage = props => {
  const [referrerId, setReferrerId] = useState("")

  useEffect(() => {
    window.scrollTo(0, 0)
    // Check if referred by a friend with query string
    // Id of referrer ?ref=xyz
    const queryParams = new URLSearchParams(props.location.search)
    const ref = queryParams.get("ref")
    console.log("URL ref:", ref)
    if (ref) return setReferrerId(ref)
    // Check if ref passed via state from Index/Chat page
    console.log("props.location.state:", props.location.state)
    const stateRef = props.location.state && props.location.state.referrerId
    if (stateRef) return setReferrerId(stateRef)
  }, [])

  return (
    <Layout>
      <SEO title="Save £10 Discount Code" />
      <Nav />
      <div className={style.main}>
        <header className={style.header}>
          <Container large={true}>
            <h1>Nature’s Finest Tops</h1>
            <h2>Landing Summer 2020</h2>
          </Container>
        </header>
        <Container large={true} containerClass={style.container}>
          <section className={style.content}>
            <div />
          </section>
          <section className={style.subscribe}>
            <SubscribeForm referrerId={referrerId} />
          </section>
        </Container>
      </div>
    </Layout>
  )
}

DiscountPage.propTypes = {}
DiscountPage.defaultProps = {}

export default DiscountPage
